import { Box, useTheme } from "@mui/material";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { hexToRgba } from "@/global/theme/utils.theme";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";

interface Props {
  renderContent?: () => React.ReactNode;
}

export function HalfScreenBanner(props: Props) {
  const { images } = useTeamConfig();
  const theme = useTheme();
  const { sm: smDown } = useCssMediaQuery("down");

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: smDown ? "350px" : "650px",
        top: "0",
        left: "0",
        backgroundImage: `url(${images?.authBackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          position: "absolute",
          top: "0",
          left: "0",
          backgroundColor: hexToRgba(theme.palette.primary.main, 0.9),
          backdropFilter: "sepia(100%)",
        }}
      />
      {props?.renderContent?.()}
    </Box>
  );
}
